module.exports = __webpack_public_path__ + "media/images/design/common/images/menu04-2b2cebad1fe8a5b2bd02ca85ea4790b9.jpg";